export default "__VITE_ASSET__5D5veYMJ__"